import React, { useMemo } from "react";
import LoginForm from "organisms/loginForm";
import OtpScreen from "organisms/otpScreen";
import CandidateOtpScreen from "organisms/CandidateOtpScreen";
import MultiCompanySelect from "organisms/multiCompanySelect";
import LoginOption from "organisms/LoginOption";
import CandidateLoginForm from "organisms/CandidateLoginForm";
import CandidateLoginContent from "organisms/CandidateLoginContent";
import OneConnectLoginContent from "organisms/OneConnectLoginContent";
import {
  buildLoginCssVars,
  getSupportText,
} from "components/candidates/CandidateLoginTheme";
import { getCustomFontStyle } from "lib/utils";
const LoginTemplate = ({
  loginDetails,
  apiError,
  apiErrorStatus,
  handleGetOTP,
  handleLogin,
  resendOtp,
  editMobile,
  handleSubmit,
  control,
  register,
  country,
  handleCountryChange,
  countryOptionsList,
  onCompanySelect,
  companyList,
  setError,
  handleLoginOptionSelect,
  setValue,
  onClickBackArrow,
  isAdmin,
  getValues,
  companyDetails,
  errors,
}) => {
  const isCandidate = !isAdmin;
  const loginTheme = useMemo(
    () => (isCandidate ? companyDetails?.theme?.loginTheme : null),
    [companyDetails, isCandidate]
  );
  const cssVars = useMemo(
    () => (loginTheme ? buildLoginCssVars(loginTheme) : {}),
    [loginTheme]
  );

  const renderSwitch = () => {
    switch (loginDetails.step) {
      case 0:
        return (
          <LoginOption handleLoginOptionSelect={handleLoginOptionSelect} />
        );
      case 1:
        return (
          <>
            {!isAdmin ? (
              <CandidateLoginForm
                theme={loginTheme}
                handleSubmit={handleSubmit}
                control={control}
                register={register}
                handleCountryChange={handleCountryChange}
                countryOptionsList={countryOptionsList}
                country={country}
                onSubmit={handleGetOTP}
                loginDetails={loginDetails}
                error={apiError}
                setError={setError}
                defaultValues={{ mobileNumber: loginDetails.mobileNumber }}
                onClickBackArrow={onClickBackArrow}
                getValues={getValues}
                setValue={setValue}
                companyDetails={companyDetails}
                errors={errors}
                supportText={getSupportText(loginTheme)}
              />
            ) : (
              <LoginForm
                handleSubmit={handleSubmit}
                control={control}
                register={register}
                handleCountryChange={handleCountryChange}
                countryOptionsList={countryOptionsList}
                country={country}
                onSubmit={handleGetOTP}
                loginDetails={loginDetails}
                error={apiError}
                setError={setError}
                defaultValues={{ mobileNumber: loginDetails.mobileNumber }}
                onClickBackArrow={onClickBackArrow}
                getValues={getValues}
                setValue={setValue}
              />
            )}
          </>
        );

      case 2:
        return isAdmin ? (
          <OtpScreen
            control={control}
            setValue={setValue}
            handleLogin={handleLogin}
            loginDetails={loginDetails}
            resendOtp={resendOtp}
            error={apiError}
            errorStatus={apiErrorStatus}
            isAdmin={isAdmin}
          />
        ) : (
          <CandidateOtpScreen
            control={control}
            setValue={setValue}
            handleLogin={handleLogin}
            loginDetails={loginDetails}
            resendOtp={resendOtp}
            error={apiError}
            errorStatus={apiErrorStatus}
            isAdmin={isAdmin}
            theme={loginTheme}
          />
        );
      case 3:
        return <MultiCompanySelect onClick={onCompanySelect} />;
    }
  };

  if (isAdmin) {
    return (
      <div className="grid md:grid-cols-2 overflow-hidden bg-Mist">
        <div className="h-[50vh] md:h-full">
          <OneConnectLoginContent />
        </div>
        <div className="">{renderSwitch()}</div>
      </div>
    );
  }

  // Themed UI mode - dynamic colors with CSS variables
  return (
    <>
      <style jsx global>{`
        ${getCustomFontStyle(companyDetails?.fontName, companyDetails?.fontPath)}
      `}</style>
      <div
        className="min-h-screen flex flex-col bg-[color:var(--login-bg)] text-[color:var(--login-text)] custom-font"
        style={cssVars}
      >
      <div className="grid md:grid-cols-2 min-h-screen overflow-hidden">
        <div
          className="relative h-full"
          style={{
            backgroundColor: loginTheme?.heroImage
              ? "transparent"
              : loginTheme?.secondaryColor,
            minHeight: '50vh',
          }}
        >
          <CandidateLoginContent
            companyDetails={companyDetails}
            theme={loginTheme}
          />
        </div>
        <div className="relative h-full flex items-center justify-center md:py-16 py-12 px-6 bg-[color:var(--login-right-bg)] text-[color:var(--login-right-text)]">
          <div className="w-full max-w-[520px]">{renderSwitch()}</div>
        </div>
      </div>
    </div>
    </>
  );
};
export default LoginTemplate;
